import index from './form-rating'

export default index